(() => {
  function mount(root) {
    if(root.dataset.requestReady)return;root.dataset.requestReady='true';
    const success=root.querySelector('.sc-request-success');
    if(success){success.focus();return;}
    const form=root.querySelector('form'),steps=[...root.querySelectorAll('[data-request-step]')];
    if(!form||steps.length!==4)return;
    const next=root.querySelector('[data-request-next]'),back=root.querySelector('[data-request-back]'),send=root.querySelector('[data-request-submit]');
    const labels=[...root.querySelectorAll('[data-step-label]')],status=root.querySelector('[data-step-status]'),review=root.querySelector('[data-request-review]');
    let current=0;form.noValidate=true;
    root.querySelector('.sc-request-steps').hidden=false;status.hidden=false;
    function invalid(step){return [...step.querySelectorAll('input,select,textarea')].find(field=>!field.checkValidity());}
    function summarize(){
      const dl=review.querySelector('dl');dl.replaceChildren();
      for(const step of steps.slice(0,3))for(const field of step.querySelectorAll('input,select,textarea')){
        if(!field.value.trim())continue;
        const row=document.createElement('div'),label=document.createElement('dt'),value=document.createElement('dd');
        label.textContent=field.labels?.[0]?.textContent.replace(/\s*\*\s*$/,'')||field.name;
        value.textContent=field.tagName==='SELECT'?field.selectedOptions[0].textContent:field.value;
        row.append(label,value);dl.append(row);
      }
      review.hidden=false;
    }
    function show(index,focus=true){
      current=index;steps.forEach((step,i)=>{step.hidden=i!==index;});
      labels.forEach((label,i)=>{if(i===index)label.setAttribute('aria-current','step');else label.removeAttribute('aria-current');label.toggleAttribute('data-complete',i<index);});
      back.hidden=index===0;next.hidden=index===3;send.hidden=index!==3;status.textContent=`${index+1} / ${steps.length}`;
      if(index===3)summarize();
      if(focus){const heading=steps[index].querySelector('h2');heading.focus({preventScroll:true});heading.scrollIntoView({block:'start',behavior:'auto'});}
    }
    next.addEventListener('click',()=>{const field=invalid(steps[current]);if(field){field.reportValidity();return;}show(Math.min(3,current+1));});
    back.addEventListener('click',()=>show(Math.max(0,current-1)));
    form.addEventListener('keydown',event=>{if(event.key==='Enter'&&event.target.tagName==='INPUT'&&current<3){event.preventDefault();next.click();}});
    form.addEventListener('submit',event=>{
      for(let i=0;i<steps.length;i++){const field=invalid(steps[i]);if(field){event.preventDefault();show(i);field.reportValidity();return;}}
      if(current!==3){event.preventDefault();show(3);}
    });
    show(root.querySelector('[data-server-error]')?3:0,false);
  }
  const init=scope=>scope.querySelectorAll('[data-custom-request]').forEach(mount);
  init(document);document.addEventListener('shopify:section:load',event=>init(event.target));
})();
